﻿import { opaccAjaxPlugin } from './vendor/script/opacc.static.js';
import { directSearchSuggestMessages } from './vendor/script/messages/opacc.messages.js';

/** @module directsearchsuggest */

/**
 * Funktionalität zur Anzeige und Interaktion mit den asynchronen Suchergebnissen
 *
 */
export class CustomDirectSearchSuggest {
	constructor() {
		this.replaceToActionUrl();

		this.searchTermAsUrlParam = true;
		this.navigationSectionSelector = '.section a';
		this.buttonOpen = document.querySelectorAll('.search-toggle');
		this.buttonClose = document.querySelectorAll('.search-head > .opc-button');
		this.wrapperElement = document.querySelectorAll('.opc-search');

		this.attachEventListener();
	}


	/**
	 *
	 *
	 */
	attachEventListener() {
		//search-toggle
		Array.from(this.buttonOpen).forEach(elem => {
			elem.addEventListener('click', (e) => {
				if (e.target.classList.contains('mobile')) {
					document.querySelector('html').classList.add('search-open');
                    let search = document.querySelector(".search-query");
                    if(search) {
                      search.focus();
                    }
				} else {
					Array.from(this.wrapperElement).forEach(wrapper => {
						let searchType = false;
						if (wrapper.dataset.opType) {searchType = wrapper.dataset.opType;}
						if(!searchType === 'fullscreen'){
							wrapper.classList.add('is-open');
						}
					});
				}
			});
		});
		Array.from(this.buttonClose).forEach(elem => {
			elem.addEventListener('click', () => {
				document.querySelector('html').classList.remove('search-open');
			});
		});
		document.addEventListener('click', (e) => {
			if (e.target.closest('.opc-search') === null) {
				Array.from(this.wrapperElement).forEach(wrapper => {
					let searchType = false;
					if (wrapper.dataset.opType) {searchType = wrapper.dataset.opType;}
					if(!searchType === 'fullscreen'){
						this.hideAsyncViewElement(wrapper);
					}
				});
			}
		});

		Array.from(this.wrapperElement).forEach(wrapper => {
			let directSearchForm = wrapper.querySelector('form');
			let timer = 0;
			// close mobile overlay on click
			let mobileSearchOverlay = directSearchForm.querySelector('.opc-button[data-op-action=\'close\']');
			if (mobileSearchOverlay) {
				mobileSearchOverlay.addEventListener('click', () => {
					wrapper.classList.remove('is-open');
				});
			}

			// keyup on input-field
			directSearchForm.querySelector('.opc-search-content > .opc-search-query > input').addEventListener('keyup', (e) => {
                let queryWrapper = e.target.closest(".opc-search-query");
                queryWrapper.classList.add("loading");
				let input = e.currentTarget;
				let asyncViewElement = wrapper.querySelector('.opc-search-results');
				if (input instanceof HTMLInputElement && this.keyCodeAllowed(e.keyCode)) {
					clearTimeout(timer);
					timer = setTimeout(() => { this.getSuggest(input, wrapper); }, 500);
					asyncViewElement.innerHTML = '';
				} else if (e.keyCode === 27) { //ESCAPE
					this.hideAsyncViewElement(wrapper);
                    queryWrapper.classList.remove("loading");
				} else if (e.keyCode === 40) { //DOWN
					asyncViewElement.querySelector(this.navigationSectionSelector).parentNode.firstElementChild.classList.add('focus').focus();
                    queryWrapper.classList.remove("loading");
				}
			});

			//Submit search
			directSearchForm.addEventListener('submit', (e) => {
				let formInputElement = e.currentTarget.querySelector('.opc-search-content > .opc-search-query > input');
				let input = this.validateSearchInput(formInputElement);
				if (input.valid) {
					let searchTermUrlParam = formInputElement.getAttribute('data-urlParam');
					let filter = this.getFilter(formInputElement);
					// add hidden-field to form
					let hidden = document.createElement('input');
					hidden.setAttribute('type', 'hidden');
					hidden.setAttribute('name', 'f-directsearchsuggest-filter-attribute');
					hidden.setAttribute('value', filter.attribute);
					directSearchForm.appendChild(hidden);

					let searchTerm = document.createElement('input');
					searchTerm.setAttribute('type', 'hidden');
					searchTerm.setAttribute('name', searchTermUrlParam);
					searchTerm.setAttribute('value', input.value);
					directSearchForm.appendChild(searchTerm);

					if (this.searchTermAsUrlParam && searchTermUrlParam) {
						let action = directSearchForm.action;
						if (action.indexOf('?') > 0) {
							action += `&${searchTermUrlParam}=${encodeURIComponent(input.value)}`;
						} else {
							action += `?${searchTermUrlParam}=${encodeURIComponent(input.value)}`;
						}
						directSearchForm.action = action;
						sessionStorage.setItem('searchActionUrl', action); // setzt temporär die Action URL in den Session Storage
					}
					return true;
				}
				e.preventDefault();
				return false;
			});

			// remove onsubmit Attribut to allow seach-submit
			directSearchForm.removeAttribute('onsubmit');
		});
	}

	/**
	 *
	 *
	 * @param {*} elem
	 * @returns {*}
	 */
	getFilter(elem) {
		let filter = elem.parentNode.querySelector('.f-directsearchsuggest-filter');
		let filterObj = {
			object: undefined,
			value: undefined,
			attribute: undefined
		};

		if (filter) {
			filterObj.object = filter;
			filterObj.value = filter.value;
			filterObj.attribute = filter.dataset.opDirectsearchsuggestFilterAttribute;
		}
		return filterObj;
	}

	/**
	 *
	 *
	 * @param {*} elem
	 * @returns {*}
	 */
	validateSearchInput(elem) {
		let inputVal = elem.value.trim();
		let minLength = elem.dataset.opMinlength;
		return {
			minimum: minLength,
			value: inputVal,
			valid: inputVal && minLength && inputVal.length >= minLength
		};
	}

	/**
	 *
	 *
	 * @param {*} elem
	 * @param {*} wrapper
	 */
	getSuggest(elem, wrapper) {
        let input = this.validateSearchInput(elem);
        let queryWrapper = elem.closest(".opc-search-query");
		if (input.valid) {
			let filter = this.getFilter(elem);
			//prepare Data for async
			let data = {
				type: 'directsearchsuggest',
				inputValue: input.value
			};

			if (filter.attribute) { data.filterAttribute = filter.attribute; }
			if (filter.value) { data.filterValue = filter.value; }
			let url = '/WebPortal/async.aspx';
			this.showAsnycViewElement(wrapper);
			opaccAjaxPlugin.fetchAsynPostForm(url, data, this.getDirectSearchSuggestDataFromResult.bind(this, wrapper), this.getDefaultErrorFnc, true);
		} else if( elem.value.trim().length > 0) {
			let msgTextNode = document.createTextNode( directSearchSuggestMessages.messageTooShort.text.replace('%1',input.minimum) );
			let msgElem = document.createElement('div');
			msgElem.setAttribute('class', 'opc-directsearch-message');
			msgElem.dataset.opType = 'info';
			msgElem.appendChild( msgTextNode );
			let asyncViewElement = wrapper.querySelector('.opc-search-results');
			asyncViewElement.insertAdjacentElement('afterbegin', msgElem);
			this.showAsnycViewElement(wrapper);
            queryWrapper.classList.remove("loading");
		} else{
			this.hideAsyncViewElement(wrapper);
            queryWrapper.classList.remove("loading");
		}
	}

	/**
	 *
	 *
	 * @param {*} wrapper
	 */
	showAsnycViewElement(wrapper){
		let asyncViewElement = wrapper.querySelector('.opc-search-results');
		asyncViewElement.classList.add('is-open');
		asyncViewElement.style.display = 'block';
	}

	/**
	 *
	 *
	 * @param {*} wrapper
	 */
	hideAsyncViewElement(wrapper){
		let asyncViewElement = wrapper.querySelector('.opc-search-results');
		if (asyncViewElement.classList.contains('is-open')) {

			asyncViewElement.classList.remove('is-open');
			asyncViewElement.style.display = 'none';

			let msgElem = asyncViewElement.querySelector('opc-directsearch-message');
			if( msgElem ){
				msgElem.remove();
			}
		}
	}

	/**
	 *
	 *
	 * @param {*} wrapper
	 * @param {*} response
	 */
	getDirectSearchSuggestDataFromResult(wrapper, response) {
		let asyncViewElement = wrapper.querySelector('.opc-search-results');
		asyncViewElement.innerHTML = response.dataAsJson.html;
        let queryWrapper = wrapper.querySelector(".opc-search-query");
        if(queryWrapper) {
          queryWrapper.classList.remove("loading");
        }
	}

	/**
	 *
	 *
	 * @param {*} keyCode
	 * @returns {*}
	 */
	keyCodeAllowed(keyCode) {
		return (keyCode !== 13 //ENTER
            &&
            keyCode !== 37 //LEFT
            &&
            keyCode !== 39 //RIGHT
            &&
            keyCode !== 38 //UP
            &&
            keyCode !== 40 //DOWN
            &&
            keyCode !== 27 //ESCAPE);
		);
	}

	/**
	 * Methode ersetzt die "GET URL" zu der "POST ACTION URL" aus dem Session Storage,
	 * damit die Paramter der URL wie die der "SearchTerm.URLParam" aus der application.cnf entsprechen.
	 */
	replaceToActionUrl() {
		var actionUrl = sessionStorage.getItem('searchActionUrl');

		if(actionUrl) {
			history.replaceState(null, 'searchActionUrl', actionUrl);
			sessionStorage.removeItem('searchActionUrl');
		}
	}
}

new CustomDirectSearchSuggest();




